import script from "./base-text-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-text-editor.vue?vue&type=script&setup=true&lang=ts"

import "./base-text-editor.vue?vue&type=style&index=0&id=a3d03b4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3d03b4a"]])

export default __exports__